<template>
  <SmartLinkItemComponent
    class="action-section"
    custom-tag="tr"
    :id="model.system.id"
    :component="!model.system.workflow"
  >
    <SmartLinkStandaloneElement
      custom-tag="td"
      class="title"
      :codename="typ.elements.title_ab74174.codename"
    >
      <RichText :value="data.title" />
      <p v-if="data.date">
        {{ dateDisplay }}
      </p>
    </SmartLinkStandaloneElement>

    <SmartLinkStandaloneElement
      v-if="hasAnyStatus"
      custom-tag="td"
      class="status"
      :codename="typ.elements.status.codename"
    >
      <span
        v-if="data.status && data.status.codename != 'no_status'"
        :class="getStatusClass(data.status, data.date ? new Date(data.date) : undefined)"
        ><span class="label-mobile">{{ $t('status') }}:</span>
        {{ $t(getStatus(data.status, data.date ? new Date(data.date) : undefined)) }}</span
      >
    </SmartLinkStandaloneElement>

    <SmartLinkStandaloneElement
      custom-tag="td"
      class="explanation"
      :codename="typ.elements.explanation.codename"
    >
      <span v-if="!isEmpty(data.explanation)" class="label-mobile">Explanation:</span>
      <RichText v-if="!isEmpty(data.explanation)" :value="data.explanation" />
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>

  <ActionItem v-for="item in data.items" :model="item" :has-any-status="hasAnyStatus" />
</template>

<script setup lang="ts">
import type { ActionItemModel } from '~/models'
import type { ActionSectionModel } from '~/models'
import { firstOrDefault } from '~/utils/first-or-default'
import { formatDateStringWithTimezone, formatWithTimezone, isEmpty } from '~/utils/kontent-helper'
import { contentTypes } from '~/models'
import { getStatusClass } from '~/utils/action-util'
import { getStatus } from '~/utils/action-util'
const typ = contentTypes.action_section
const pageStore = usePageStore()
const props = defineProps<{
  model: ActionSectionModel
  hasAnyStatus: boolean
}>()

const data = {
  title: props.model.elements.titleAb74174.value,
  explanation: props.model.elements.explanation.value,
  date: props.model.elements.date.value || '',
  dateTimeZone: props.model.elements.date.displayTimeZone || '',
  items: pageStore.getListAs<ActionItemModel>(props.model.elements.actionItems.value),
  status: firstOrDefault(props.model.elements.status.value),
  dateDisplayOption: props.model.elements.dateDisplayOption.value[0]?.codename
}

const dateDisplay = computed(() => {
  switch (data.dateDisplayOption) {
    case contentTypes.action_section.elements.date_display_option.options.no_date.codename:
      return ''
    case contentTypes.action_section.elements.date_display_option.options.date.codename:
      return formatDateStringWithTimezone(data.date, data.dateTimeZone)
    case contentTypes.action_section.elements.date_display_option.options.date_and_time.codename:
      return formatWithTimezone(data.date, data.dateTimeZone)
    default:
      return formatDateStringWithTimezone(data.date, data.dateTimeZone)
  }
})
</script>
